export const COMPONENT_NAME = 'Breadcrumb';
export const COMPONENT_GRID_CONTAINER = 'Breadcrumb-GridContainer';
export const COMPONENT_GRID_BLOCK = 'Breadcrumb-GridBlock';
